import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { Upload, message, Button, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PageLayout from '../../components/PageLayout';

var _ = require('lodash');

const useStyles = createUseStyles({

})

const conf = (auth) => {
    return {
        multiple: true,
        showUploadList: false,
        name: 'file',
        accept: ".csv",
        action: auth.domain + '/api/upload/tinkoff/bank',
        headers: {
            authorization: 'Bearer ' + auth.getToken(),
        },
        onDownload(file) {
            // console.log(file);
        },
        onChange(info) {
            if (info.file.status === 'done') {
                var data = info.file.response;
                if (data && data.message && data.status === false) {
                    message.error(data.message, 10);
                    return false;
                }
                // saveByteArray([info.file.response], info.file.name, info.file.type);
                message.success(`${info.file.name} файл успешно загружен`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} ошибка загрузки файла.`, 10);
            }
        }
    }
};

export default function FederationadministratorManagementEkvairing(props) {
    const classes = useStyles()
    const { auth } = props;

    const [fileList, setFileList] = React.useState([]);
    const [uploading, setUploading] = React.useState(false);

    const handleUpload = () => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('files[]', file);
        });
        setUploading(true); // You can use any AJAX library you like

        fetch(auth.domain + '/api/upload/ekvairing/tinkoff', {
            method: 'POST',
            headers: {
                authorization: 'Bearer ' + auth.getToken(),
            },
            body: formData,
        })
            .then((res) => res.json())
            .then((data) => {
                if (data && data.message && data.status === false) {
                    message.error(data.message, 10);
                    return false;
                }
                setFileList([]);
                message.success('Загрузка завершена.');
            })
            .catch(() => {
                message.error('Ошибка загрузки.');
            })
            .finally(() => {
                setUploading(false);
            });
    };

    const propsUpload = {
        multiple: true,
        // showUploadList: false,
        accept: ".csv",
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file, files) => {
            if (!files || !files.length) {
                return false;
            }  
            
            //Убираем дубликаты
            let nFiles = []
            for (let i = 0; i < files.length; i++) {
                //Если выбана папка или не файл .csv, то пропускаем файл
                if (!files[i].name.endsWith(".csv")) {
                    continue
                }

                let exist = false;
                for (let j = 0; j < fileList.length; j++) {
                    if(files[i].name === fileList[j].name) {
                        exist = true;
                        break;
                    }
                }

                if (!exist) {
                    nFiles.push(files[i]);
                }
                
            }
            
            setFileList([...fileList, ...nFiles]);
            return false;
        },
        fileList,
    };

    return (
        <PageLayout>
            <Card size="small" className={classes.block} style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                <Upload {...conf(auth)}>
                    <Button icon={<UploadOutlined />}>Импортировать отчет банка</Button>
                </Upload>
            </Card> 
            <Card size="small" className={classes.block} style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                <Upload {...propsUpload}>
                    <Button icon={<UploadOutlined />}>Выбрать файлы оплат</Button>
                </Upload>
                <Button
                    type="primary"
                    onClick={handleUpload}
                    disabled={fileList.length === 0}
                    loading={uploading}
                    style={{
                        marginTop: 16,
                    }}
                >
                    {uploading ? 'Идет загрузка' : 'Начать загрузку'}
                </Button>
            </Card>
        </PageLayout>
    );
}
